<template>
  <header>
    <div>
      <div class="brand">FrontEnd Assignment</div>
      <div class="desc">To <a href="https://trainn.co">Trainn</a></div>
    </div>
    <div class="text">
      By <a href="https://balathanusan.github.io">Balathanusan Jeyarajah</a>
    </div>
  </header>
</template>

<script>
export default {
  name: "Header",
};
</script>